module.exports = __webpack_public_path__ + "img/jiebanglogo-02.7219e637.png";